import { modalAnatomy as parts } from '@chakra-ui/anatomy'
import { createMultiStyleConfigHelpers } from '@chakra-ui/styled-system'
import { defineStyle } from '@chakra-ui/react'

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(parts.keys)
const baseStyle = definePartsStyle({
  overlay: {
    // neutral.900 can't use opacity, its animated
    bg: 'rgb(0 25 55 / 60%)'
  },
  body: {
    position: 'relative',
    py: {
      base: '44px',
      modalContentMedium: '100px'
    },
    px: {
      base: '48px',
      modalContentMedium: '40px'
    }
  },
  dialog: {
    maxW: '940px',
    mt: {
      base: 0,
      modalContentMedium: '160px'
    },
    mx: {
      base: 0,
      modalContentMedium: '20px'
    },
    borderRadius: {
      base: 0,
      modalContentMedium: '20px'
    },
    boxShadow: '0 0 0 8px rgba(255, 255, 255, 0.3)',
    background: '#FFFFFF'
  }
})
const sizes = {
  base: definePartsStyle({
    dialog: defineStyle({
      // override base dialog maxW set here:
      // https://github.com/chakra-ui/chakra-ui/blob/main/packages/components/theme/src/components/modal.ts#LL98C4-L98C29
      dialog: {}
    })
  })
}

export const ModalTheme = defineMultiStyleConfig({
  baseStyle,
  sizes
})

